module.exports = __webpack_public_path__ + "img/demo.06fc08e9.jpg";